import React from "react";

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import logo from './logo.svg';
import check from './check.svg';

import './App.css';

const ErrorPage = () => {
  return <div className="App-error">
    Этой страницы здесь точно нет. Воспользуйтесь меню.
  </div>
}

const About = () => {
  return (
    <div>
      <ul className="App-features">
        <li>
          <img src={check} className="Check" alt="check"/> <strong>Python (Django Rest Framework / Fast API)</strong> -
          чтобы быстро поставлять обновления платформы
        </li>
        <li>
          <img src={check} className="Check" alt="check"/> <strong>PostgreSQL</strong> - здесь храним данные
        </li>
        <li>
          <img src={check} className="Check" alt="check"/> <strong>Kafka</strong> - интеграция данных между продуктами
          производственной системы
        </li>
        <li>
          <img src={check} className="Check" alt="check"/> <strong>React (ant.design, Samolet UI)</strong> - для
          отзывчивых, удобных и красивых интерфейсов
        </li>
        <li>
          <img src={check} className="Check" alt="check"/> <strong>K8S + Harbor</strong> - для деплоймента и
          масштабирования
        </li>
        <li>
          <img src={check} className="Check" alt="check"/> <strong>Py.test + Locust + Playwright</strong> - для
          тестирования
        </li>
      </ul>
    </div>
  )
}


const Features = () => {
  return (
    <div>
      <ul className="App-features">
        <li>
          <img src={check} className="Check" alt="check"/> <strong>Интеграция с производственной системой
          самолета</strong> -
          объединяем, обогощаем и используем данные других продуктов для лучшего пользовательского опыта
        </li>
        <li>
          <img src={check} className="Check" alt="check"/> <strong>Рабочее время</strong> - календарь и планирование
          рабочего времени для руководителей и сотрудников
        </li>
        <li>
          <img src={check} className="Check" alt="check"/> <strong>HR сервисы для сотрудников компании</strong> - взять
          отпуск, оформить командировку, добавить новую штатную позицию - без проблем
        </li>
        <li>
          <img src={check} className="Check" alt="check"/> <strong>Интеграция с внешней системой подбора</strong> -
          поиск кандидатов на открытые позиции, отслеживание статуса заявок на подбор и другие сервисы
        </li>
        <li>
          <img src={check} className="Check" alt="check"/> <strong>Структура штатного расписания</strong> - сервисы
          управления структурой подразделений для руководителей
        </li>
        <li>
          <img src={check} className="Check" alt="check"/> <strong>Профиль сотрудника</strong> - информация о коллегах
          для всех сотрудников самолета
        </li>
        <li>
          <img src={check} className="Check" alt="check"/> <strong>РОСТ</strong> - инструмент для performance review
          внутри компании
        </li>
      </ul>
    </div>
  )
}


const AppMenu = () => {
  return <div className="App-menu">
    <a href="/">Технологии</a> |
    <a href="/features">Возможности</a>
  </div>
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <About/>,
    errorElement: <ErrorPage/>,
  },
  {
    path: "/features",
    element: <Features/>,
    errorElement: <ErrorPage/>,
  },
]);

const App = () => {
  return (
    <div className="App">
      <section className="App-content">
        <img src={logo} className="App-logo" alt="smlt"/>
        <h1>HR-платформа полного цикла для наших сотрудников</h1>
        <AppMenu/>
        <RouterProvider router={router}/>
        <a href="https://samolet.ru/" target="_blank" rel="noreferrer">www.samolet.ru</a>
      </section>
    </div>
  );
}

export default App;
